/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import RtcClient from '@/lib/RtcClient';
import Operation from './components/Operation';
import { setHistoryMsg, setInterruptMsg } from '@/store/slices/room';
import styles from './index.module.less';

function Menu() {
  const dispatch = useDispatch();
  const [question, setQuestion] = useState('');
  const room = useSelector((state: RootState) => state.room);
  const isJoined = room?.isJoined;

  useEffect(() => {
    if (question && !room.isAITalking) {
      dispatch(setInterruptMsg());
      dispatch(
        setHistoryMsg({
          text: question,
          user: RtcClient.basicConfig.uid,
          paragraph: true,
          definite: true,
        })
      );
      setQuestion('');
    }
  }, [dispatch, question, room.isAITalking]);

  return (
    <div className={styles.wrapper}>
      {isJoined ? (
        <div className={`${styles.box} ${styles.info}`}>
          <div className={styles.gray}>房间ID {room.roomId || '-'}</div>
        </div>
      ) : (
        ''
      )}
      {isJoined ? <Operation /> : ''}
    </div>
  );
}

export default Menu;
